import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 19L2 12L9 5L10.05 6.05L4.85 11.25H22V12.75H4.85L10.05 17.95L9 19Z", fill: "#474749" }));
export default SvgArrowLeft;
